export function cutoffDate(daysBack = 14) {
const d = new Date();
d.setDate(d.getDate() - daysBack);
return d;
}


export function timeAgo(date) {
// Convertir a Date si es string o timestamp
if (!date) return 'N/A';
const dateObj = date instanceof Date ? date : new Date(date);

// Verificar que la fecha sea válida
if (isNaN(dateObj.getTime())) return 'N/A';

const now = new Date();
const diff = now - dateObj;
const s = Math.floor(diff / 1000);
const m = Math.floor(s / 60);
const h = Math.floor(m / 60);
const d = Math.floor(h / 24);
if (d > 0) return d + 'd';
if (h > 0) return h + 'h';
if (m > 0) return m + 'm';
return Math.max(s, 1) + 's';
}


export function hostname(link) {
try { return new URL(link, window.location.href).hostname; } catch { return link; }
}